module.exports = function () {
  const updaterPathName = "/services/updater/";
  if (window.location.pathname !== updaterPathName) {
    window.location.replace(updaterPathName);
  }
};
